import React, { Component } from 'react'
import Img from 'react-cool-img'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import ScrollToTop from 'react-scroll-to-top'
import Web3 from 'web3'
import ZonuletNFT from '../../abis/ZonuletNFT.json'

class NftForSale extends Component {
  render() {
    return (
      <div>
        <div className="head-title col-auto mx-4">
          <h4 className="mb-0 font-weight-normal">Old NFTs For Sale</h4>
        </div>
        <div className="container-fluid mb-5 explore-adj">
          <div className="row justify-content-around">
            <p align="center" className="text-secondary">
              This is where you can explore Zonulet NFTs for sale, you can purchase any NFT listed here with ZONU!
            </p>
            <div align="center">
              <a href="/explore/newest" className="btn btn-primary">
                Newest NFTs For Sale
              </a>
              <br />
              <br />
            </div>
            <ReactPlaceholder
              type="rect"
              ready={this.state.ready}
              showLoadingAnimation={true}
              color="#333"
              style={{ width: '300px', height: '300px', borderRadius: '15px' }}
            >
              {this.state.images.map((id, key) => {
                return (
                  // (this.state.approved[key] && (this.state.owners[key] !== this.state.account) && this.state.ready === true) ?
                  // <ReactPlaceholder type='rect' ready={this.state.approved[key] && this.state.ready} showLoadingAnimation={true} color='#333' style={{ width: '300px', height: '300px', borderRadius: '15px' }}>

                  this.state.approved[key] && this.state.ready === true ? (
                    <div key={key} className="col-md-3 card bg-light m-3 p-0">
                      <Link
                        to={{
                          pathname: `/nft/${this.state.imageData_id[key]}`,
                          // state: {name: "vikas"}
                        }}
                      >
                        <form onSubmit={event => {}}>
                          <div className="col-auto max-250">
                            <div className="text-secondary idbadge" align="center">
                              ID #{this.state.imageData_id[key]}
                            </div>
                            {typeof this.state.imageData_nftData[key] !== 'undefined' ? (
                              this.state.imageData_mimeType[key] === 'image/jpeg' ||
                              this.state.imageData_mimeType[key] === 'image/png' ||
                              this.state.imageData_mimeType[key] === 'image/gif' ? (
                                <img
                                  alt="NFT"
                                  className="token rounded"
                                  src={'https://zonulet.infura-ipfs.io/ipfs/' + this.state.imageData_nftData[key]}
                                />
                              ) : this.state.imageData_mimeType[key] === 'video/mp4' ? (
                                <video
                                  alt="NFT"
                                  className="token rounded"
                                  autoPlay={true}
                                  muted={true}
                                  loop={true}
                                  controls
                                  playsInline
                                  src={'https://zonulet.infura-ipfs.io/ipfs/' + this.state.imageData_nftData[key]}
                                  type="video/mp4"
                                >
                                  <source
                                    src={
                                      'https://zonulet.infura-ipfs.io/ipfs/' + this.state.imageData_nftData[key]
                                    }
                                    type="video/mp4"
                                  ></source>
                                </video>
                              ) : this.state.imageData_mimeType[key] === 'model/gltf-binary' ? (
                                <model-viewer
                                  src={'https://zonulet.infura-ipfs.io/ipfs/' + this.state.imageData_nftData[key]}
                                  alt={this.state.imageData_name[key]}
                                  ar
                                  ar-modes="webxr scene-viewer quick-look"
                                  environment-image="neutral"
                                  auto-rotate
                                  camera-controls
                                  style={{ width: '100%', height: '250px' }}
                                ></model-viewer>
                              ) : null
                            ) : null}
                          </div>
                          <div className="m-2" align="center">
                            {this.state.imageData_name[key]}
                          </div>
                          <div className="m-2" align="center">
                            {'Price: ' + this.state.imageData_price[key]}
                            <img alt="main" className="eth-class" src="../zonulet_stndr_1.svg" />
                          </div>
                          <div className="m-2" align="center">
                            <span style={{ fontSize: '13px' }}>
                              ≈ ${this.state.imageData_usdprice[key]} <small>USD</small> or ≈{' '}
                              {this.state.imageData_oneprice[key]} <small>ONE</small>
                            </span>
                          </div>
                        </form>
                      </Link>
                    </div>
                  ) : null

                  // </ReactPlaceholder>
                )
              })}
            </ReactPlaceholder>
          </div>
        </div>
      </div>
    )
  }

  constructor(props) {
    super(props)
    this.state = {
      account: '',
      contract: null,
      sale_contract: null,
      totalSupply: 0,
      images: [],
      owners: [],
      imageData_name: [],
      imageData_nftData: [],
      imageData_mimeType: [],
      imageData_category: [],
      imageData_price: [],
      imageData_id: [],
      imageData_oneprice: [],
      imageData_usdprice: [],
      selling_to: '',
      selling_price: null,
      token_sale_contract: null,
      token_price: 0,
      approved: [],
    }
  }

  async UNSAFE_componentWillMount() {
    await this.loadFilecoinData()
    // await this.loadTokenSaleContract()
  }

  async loadFilecoinData() {

    const web3 = new Web3('https://rpc.onechain.services')


    const networkId = 1666600000
    const networkData = ZonuletNFT.networks[networkId]
    if (networkData) {
      const abi = ZonuletNFT.abi
      const address = networkData.address
      const contract = new web3.eth.Contract(abi, address)

      // console.log(contract)
      this.setState({ contract })
      const totalSupply = await contract.methods.totalSupply().call()
      // console.log(totalSupply)
      this.setState({ totalSupply })

      const abiblack = [{"stateMutability":"nonpayable","type":"constructor","inputs":[]},{"type":"event","name":"SetBlackListedAddress","inputs":[{"internalType":"address","indexed":true,"name":"hashAddress","type":"address"},{"name":"blacklisted","type":"bool","indexed":false,"internalType":"bool"}],"anonymous":false},{"inputs":[{"name":"nftID","indexed":true,"type":"uint256","internalType":"uint256"},{"name":"blacklisted","type":"bool","indexed":false,"internalType":"bool"}],"name":"SetBlackListedNFT","anonymous":false,"type":"event"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"idupdates","type":"function","outputs":[{"name":"","type":"uint256","internalType":"uint256"}],"stateMutability":"view"},{"inputs":[],"name":"owner","stateMutability":"view","type":"function","outputs":[{"internalType":"address","type":"address","name":""}]},{"type":"function","outputs":[{"type":"address","name":"","internalType":"address"}],"stateMutability":"view","name":"updates","inputs":[{"type":"uint256","internalType":"uint256","name":""}]},{"outputs":[],"stateMutability":"nonpayable","inputs":[{"internalType":"address","name":"addy","type":"address"},{"internalType":"bool","name":"blacklisted","type":"bool"}],"type":"function","name":"setBlackListedAddress"},{"inputs":[{"internalType":"uint256","name":"nftID","type":"uint256"},{"internalType":"bool","name":"blacklisted","type":"bool"}],"name":"setBlackListedNFT","outputs":[],"type":"function","stateMutability":"nonpayable"},{"outputs":[{"type":"bool","internalType":"bool","name":""}],"stateMutability":"view","name":"getBlackListedAddress","inputs":[{"name":"blAddress","internalType":"address","type":"address"}],"type":"function"},{"type":"function","name":"getBlackListedNFT","inputs":[{"name":"nftID","type":"uint256","internalType":"uint256"}],"stateMutability":"view","outputs":[{"internalType":"bool","type":"bool","name":""}]},{"stateMutability":"view","name":"AddyCount","type":"function","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"inputs":[]},{"outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"type":"function","inputs":[],"name":"IDCount","stateMutability":"view"}]      

      const contractblack = new web3.eth.Contract(abiblack, '0xbE40C5586edFAB7D296d1BF0fBd8bB56Ca4436CC')

      this.setState({ contractblack })
      const abip = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"getLatestONEPrice","outputs":[{"internalType":"int256","name":"","type":"int256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"pairAddress","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getLatestTokenPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"}]

      const addp = '0x12Ba58BEb1F85cBEa91DB3Bf7681f66CAadF0fd6' //ZonuletPriceOracle
      const contractp = new web3.eth.Contract(abip, addp)
      this.setState({ contractp })

      const oneprice = (await contractp.methods.getLatestONEPrice().call()) / 1e8
      const zonuperOne = await contractp.methods.getLatestTokenPrice('0x06e6914ae4ee358b28eb613bbdff2c2ea7409523', 1).call() //PAIRS
      const zonuUsd = oneprice / (zonuperOne / 1e18)

      var SI_SYMBOL = ['', 'k', 'M', 'B', 'T', 'P', 'E']

      function abbreviateNumber(number) {
        // what tier? (determines SI symbol)
        var tier = (Math.log10(Math.abs(number)) / 3) | 0

        // if zero, we don't need a suffix
        if (tier == 0) return number

        // get suffix and determine scale
        var suffix = SI_SYMBOL[tier]
        var scale = Math.pow(10, tier * 3)

        // scale the number
        var scaled = number / scale

        // format number and add suffix
        return scaled.toFixed(1) + suffix
      }

     
      for (var i = 0; i < totalSupply; i++) {
        const metadata = await contract.methods.imageData(i).call()
        const blacklisted = await contractblack.methods.getBlackListedNFT(i).call()
        // console.log(metadata)
        if (!blacklisted) {
          this.setState({
            images: [...this.state.images, metadata.name],
            imageData_name: [...this.state.imageData_name, metadata.name],
            imageData_nftData: [...this.state.imageData_nftData, metadata.nftData],
            imageData_mimeType: [...this.state.imageData_mimeType, metadata.mimeType],
            imageData_category: [...this.state.imageData_category, metadata.category],
            imageData_price: [...this.state.imageData_price, abbreviateNumber(metadata.price)],
            imageData_usdprice: [...this.state.imageData_usdprice, Number(metadata.price * zonuUsd).toFixed(2)],
            imageData_oneprice: [...this.state.imageData_oneprice, Number((metadata.price / zonuperOne) * 1e18).toFixed(2),],
            imageData_id: [...this.state.imageData_id, i],
          })
          var approv = await contract.methods.isApprovedOrOwner('0x012679e9bC9eA6a07dA6b9Fc267a81940A7F183E', i).call() //ZonuletNFTSale
          this.setState({ approved: [...this.state.approved, approv] })

          this.setState({ ready: true })
        }
      }

   
    } else {
      toast.error("Switch to Harmony Mainnet!")
    }


  }


}
export default NftForSale
